import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import { Card, CardBody } from '@dbk/ui-card';

import styles from './list-view.styles';

class ListViewRow extends PureComponent {
  static propTypes = {
    markerStyle: PropTypes.shape({
      fill: PropTypes.string,
    }),
    children: PropTypes.node,
    testID: PropTypes.string,
    isActive: PropTypes.bool,
    onLayout: PropTypes.func,
    customeStyle: PropTypes.object,
  };

  static defaultProps = {
    testID: 'list-view-row',
    isActive: false,
    customeStyle: {}
  };

  render() {
    const {children, testID, isActive, onLayout} = this.props;
    return (
      <View onLayout={onLayout} style={styles.rowRoot} testID={testID}>
        <View className="adjust-width" style={styles.rowContent}>
          <Card active={isActive}>
            <CardBody>
              {children}
            </CardBody>
          </Card>
        </View>
      </View>
    );
  }
}

export default ListViewRow;
